export default "__VITE_ASSET__13f8281f__"